import { render, staticRenderFns } from "./ObjectifCarriereFormation.vue?vue&type=template&id=24bb95be"
import script from "./ObjectifCarriereFormation.vue?vue&type=script&lang=js"
export * from "./ObjectifCarriereFormation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports